// Maps the backend status code for password-change endpoints to a localized
// message key (mirrors the legacy GetChangePasswordFeedback).
export function passwordFeedbackKey(status?: number): string {
    switch (status) {
        case 200:
            return 'passwordFeedback.ok';
        case 400:
            return 'passwordFeedback.badRequest';
        case 401:
            return 'passwordFeedback.unauthorized';
        case 406:
            return 'passwordFeedback.userNotFound';
        default:
            return 'passwordFeedback.default';
    }
}
